import React from 'react'
import styled from 'styled-components'

import { NavigationTab } from 'components'

type Tab = {
  label: string
  tabId: string
  onClick: () => void
}

type Props = {
  activeTab?: string
  tabs: Tab[]
}

const SimpleNavigationTab: React.FC<Props> = ({ activeTab, tabs = [] }) => (
  <TabsContainer>
    {tabs.map((tab, index) => (
      <TabContainer onClick={tab.onClick} key={`${index}-${tab.tabId}`}>
        <NavigationTab variant="simple" {...tab} active={activeTab === tab.tabId} />
      </TabContainer>
    ))}
  </TabsContainer>
)

const TabsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  position: relative;
  width: 100%;
  border-bottom: 1px solid ${(p) => p.theme.colors.gray4};

  a {
    margin-left: 24px;
    text-decoration: none;
  }
`

const TabContainer = styled.div`
  cursor: pointer;
  margin-left: 24px;
`

export default SimpleNavigationTab
